import React from 'react';
import { Typography, Grid } from '@material-ui/core';

const FailReg = (props) => {

    const NavTo = (route) => {
        props.history.push(route);
    }

    const style = {
        "padding": "20px"
    }

    const linkStyle = {
        "text-decoration":"underline"
    }

    return (
        <Grid container justify="center" style={style}>
            <Grid item>
                <Grid container>
                    <Typography variant="body1">Dit blyk asof u epos reeds geregistreer is op DigiInskryf.</Typography>
                </Grid>            
            </Grid>
            <Grid item>
                <Grid container>
                    <Typography variant="body1">
                        Probeer asseblief weer inteken deur om <span style={linkStyle} onClick={() => NavTo('tekenin')}>HIER</span> te klik, of klik <span style={linkStyle} onClick={() => NavTo('stuurmywagwoord')}>HIER</span> om jou wagwoord weer te epos.
                        </Typography>

                </Grid>
            </Grid>
        </Grid>
        )

}

export default FailReg;


// WEBPACK FOOTER //
// ./src/components/FailReg.js